import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { startCase } from "lodash";
import { useFormikContext } from "formik";
import { AddClientFormValues } from "../../types";

const removeLegacyValue = (pricingPlan?: string) => {
  if (
    !["free", "starter", "standard", "complete", "enterprise"].includes(
      pricingPlan || "",
    )
  ) {
    return "";
  }
  return pricingPlan;
};

function PricingPlanSelect() {
  const { handleChange, values, errors, touched } =
    useFormikContext<AddClientFormValues>();

  return (
    <FormControl
      fullWidth
      sx={{
        marginTop: "2%",
        width: "100%",
        float: "right",
      }}
      variant="standard"
    >
      <InputLabel id="client-pricing-plan-label" htmlFor="client-pricing-plan">
        Pricing Plan
      </InputLabel>
      <Select
        fullWidth={true}
        id="client-pricing-plan"
        data-testid="client-pricing-plan-edit"
        name="client-pricing-plan"
        value={removeLegacyValue(values["client-pricing-plan"])}
        onChange={handleChange}
        error={
          touched["client-pricing-plan"] &&
          Boolean(errors["client-pricing-plan"])
        }
      >
        {["free", "starter", "standard", "complete", "enterprise"].map((o) => (
          <MenuItem key={o} value={o} disabled={o === "enterprise"}>
            {startCase(o)}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText sx={{ marginLeft: 0 }} color="error">
        {errors["client-pricing-plan"]}
      </FormHelperText>
      <FormHelperText>
        ℹ️ Enterprise plans must be set up in the{" "}
        <a href="https://dashboard.stripe.com/products?active=true">
          Stripe Dashboard
        </a>
        .
      </FormHelperText>
    </FormControl>
  );
}

export default PricingPlanSelect;
